import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AgentTaxRecords() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/agent/tax-records").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);

  return (
    <div data-testid="agent-tax-records-page">
      <div className="eyebrow mb-2">County Data</div>
      <h1 className="aperture-h1 text-4xl mb-10">Tax Records.</h1>

      <div className="bg-white rounded-sm border overflow-x-auto" style={{ borderColor: "rgba(10,37,64,0.10)" }}>
        <table className="w-full text-sm">
          <thead className="bg-navy/5"><tr>{["Parcel ID","County","Tax Bill","Last Updated"].map(h=><th key={h} className="px-4 py-3 text-left eyebrow" style={{color:"#0A2540"}}>{h}</th>)}</tr></thead>
          <tbody>
            {rows === null && <tr><td colSpan="4" className="px-4 py-10 text-center text-navy/50">Loading…</td></tr>}
            {rows?.length === 0 && <tr><td colSpan="4" className="px-4 py-10 text-center text-navy/50">No tax records yet.</td></tr>}
            {rows?.map((r) => (
              <tr key={r.parcel_id} className="border-t" data-testid={`tax-row-${r.parcel_id}`} style={{ borderColor: "rgba(10,37,64,0.08)" }}>
                <td className="px-4 py-3 font-mono text-xs">{r.parcel_id}</td>
                <td className="px-4 py-3">{r.county || "—"}</td>
                <td className="px-4 py-3">${Number(r.tax_bill_amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                <td className="px-4 py-3 text-navy/60 text-xs">{r.last_updated ? new Date(r.last_updated).toLocaleDateString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
